<template>
  <div class="c-content-block">
    <sc-text tag="div" v-if="fields && fields.label" :field="fields.label" class="label" />
    <sc-text tag="div" v-if="fields && fields.title" :field="fields.title" class="title" />
    <div class="description">
      <sc-text v-if="fields && fields.description" :field="fields.description" />
    </div>
    <sc-placeholder name="jss-content-block-with-label-links" :rendering="rendering" />
  </div>
</template>

<script>
import { Text, Placeholder } from '@sitecore-jss/sitecore-jss-vue';

export default {
  name: 'CIS-Content-Block-With-Label',
  components: {
    ScText: Text,
    ScPlaceholder: Placeholder
  },
  props: {
    fields: {
      type: Object
    },
    rendering: {
      type: Object
    }
  }
};
</script>
<style lang="scss" scoped>
.c-content-block {
  margin-bottom: 4rem;

  @include desktop-up {
    margin-bottom: 5rem;
  }

  .label {
    display: inline-block;
    @include font-styles('Arial', 1.4rem, 600, normal, 1.6rem, normal, $white);
    background-color: $dark-blue;
    margin-bottom: 1rem;
    padding: 0.6rem 1rem;
    text-transform: uppercase;
  }

  .title {
    display: block;
    @include font-styles('Arial', 1.6rem, 500, normal, 2.2rem, normal, $dark-blue);
    margin-bottom: 0.8rem;

    @include desktop-up {
      font-size: 2rem;
      line-height: 2.6rem;
    }
  }

  .description {
    @include font-styles('Arial', 1.6rem, 300, normal, 2rem, normal, $dark-blue);
    margin-bottom: 2rem;

    @include desktop-up {
      font-size: 2rem;
      line-height: 2.6rem;
    }
  }

  &:deep() {
    .c-cta--tertiary {
      line-height: 2.2rem;
      padding: 0.8rem 0;
      margin-bottom: 1rem;

      &:after {
        margin-top: 0.2rem;
        height: 1.3rem;
        min-height: 1.3rem;
      }
    }
  }
}
</style>
